import { z } from "zod";

/**
 * Persisted media / document JSON shape used on Delivery fields such as
 * `docs` and `validationDocs`, and mirrored by mobile `UploadedFile`.
 *
 * - `key` — raw S3 object key (source of truth; unencoded)
 * - `url` — public object URL derived via `@repo/utils` `buildS3ObjectUrl`
 * - `name` / `label` — human-facing original filename for UI
 *
 * Do not put device-local paths (`localUri`) here — that is mobile ephemeral
 * state and must not be part of the cross-app persisted contract.
 *
 * Always derive `url` from `key` with the shared S3 helpers; do not hand-build
 * `s3.amazonaws.com` URLs from raw keys (encoding / region bugs).
 */
export const StoredMediaFileSchema = z.object({
  key: z.string().min(1),
  url: z.string().min(1),
  name: z.string().optional(),
  label: z.string().optional(),
  type: z.string().optional(),
});

export const StoredMediaFilesSchema = z.array(StoredMediaFileSchema);

export type StoredMediaFile = z.infer<typeof StoredMediaFileSchema>;
export type StoredMediaFiles = z.infer<typeof StoredMediaFilesSchema>;
